import "./todosLoading.css"
function TodosLoading() {
    return (
        <div className="loading-container">
            <p>Cargando...</p>
            <div className="pelota"/>
        </div>
    )
}
export { TodosLoading }